import React from "react";
import { Button, Card, CardContent, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTheme } from "../context/ThemeContext"; // 🔥 Dark mode támogatás
import { useNavigate } from "react-router-dom";
import { getUserRole } from "../utils/Auth";

const ProductList = ({
  products,
  handleEdit,
  handleDelete,
  showProductActions,
}) => {
  const { darkMode } = useTheme(); // 🔥 Dark mode állapot
  const navigate = useNavigate();
  const role = getUserRole();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      {products.map((product) => {
        const productImage = product.imageUrl || "/images/default-product.jpg";

        return (
          <Card
            key={product.id}
            sx={{
              bgcolor: darkMode ? "#303030" : "#D1D5DB", // 🔥 Sötétszürke háttér dark mode-ban, világosszürke világos módban
              color: darkMode ? "white" : "black",
              borderRadius: "12px",
              boxShadow: 3,
              textAlign: "center",
            }}
          >
            <img
              src={productImage}
              alt={product.name}
              className="w-full h-40 object-cover rounded-t-lg cursor-pointer"
              onClick={() => navigate(`/products/${product.id}/slabs`)}
            />

            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {product.name}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: darkMode ? "#d1d5db" : "#374151",
                  fontWeight: "bold",
                }}
              >
                {product.displayedPrice} EUR / {product.unitType}
              </Typography>

              <Typography
                variant="body2"
                sx={{ color: "red", fontWeight: "bold", fontSize: "18px" }}
              >
                {product.availableStock} {product.unitType} în
                stoc
              </Typography>

              <div className="mt-3 flex flex-col gap-2 items-center">
                {showProductActions && (
                  <div className="mt-3 flex gap-2 w-full">
                    <Button
                      variant="contained"
                      startIcon={<EditIcon />}
                      sx={{
                        flex: 1,
                        bgcolor: darkMode ? "#1976d2" : "#1565c0",
                        color: "white",
                        "&:hover": {
                          bgcolor: darkMode ? "#1565c0" : "#1976d2",
                        },
                        borderRadius: "30px",
                        padding: "12px 24px",
                      }}
                      onClick={() => handleEdit(product)}
                    >
                      Editare
                    </Button>

                    <Button
                      variant="contained"
                      startIcon={<DeleteIcon />}
                      color="error"
                      sx={{
                        flex: 1,
                        borderRadius: "30px",
                        padding: "12px 24px",
                      }}
                      onClick={() => handleDelete(product.id, product.name)}
                    >
                      Ștergere
                    </Button>
                  </div>
                )}
                <Button
                  variant="outlined"
                  sx={{
                    borderRadius: "30px",
                    padding: "12px 24px",
                    mt: 1,
                    fontSize: "16px",
                    color: darkMode ? "#90caf9" : "#0d47a1",
                    borderColor: darkMode ? "#90caf9" : "#0d47a1",
                    width: "100%",
                    "&:hover": {
                      backgroundColor: darkMode ? "#1976d2" : "#e3f2fd",
                    },
                  }}
                  onClick={() => navigate(`/products/${product.id}/slabs`)}
                >
                  Vezi lastre
                </Button>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default ProductList;
